import React, { lazy, Suspense } from 'react'
import Progress from 'core/components/progress/Progress'
import withFormContext from 'core/components/validatedForm/withFormContext'

// Lazy load CodeMirror to reduce initial bundle size (219 KB library)
const CodeMirror = lazy(() => import('core/components/codeMirror/CodeMirror'))

// Wrapper component that handles Suspense
const CodeMirrorWithSuspense = (props: any) => (
  <Suspense fallback={<Progress loading={true} />}>
    <CodeMirror {...props} />
  </Suspense>
)

export default withFormContext(CodeMirrorWithSuspense)
